const core = require('./core');
const thirdParty = require('./thirdParty');
const pricing = require('./pricing');
const driverPay = require('./driverPay');

var _parent = {};

module.exports = {
    init: (p) => (_parent = p),
    core: core,
    thirdParty: thirdParty,
    pricing: pricing,
    driverPay: driverPay
};